import React, { useEffect } from "react";
import { Bell, CheckCircle2, ShieldAlert, TriangleAlert } from "lucide-react";
import { useData } from "../contexts/DataContext";
import { formatDateTime, getStatusLabel, getStatusTone } from "../lib/utils";

const iconsByCategory = {
  trip_started: CheckCircle2,
  vehicle_approaching: Bell,
  handover_verified: CheckCircle2,
  incident_logged: TriangleAlert,
};

export default function NotificationsPage() {
  const { notifications, loadNotifications } = useData();

  useEffect(() => {
    loadNotifications();
  }, [loadNotifications]);

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="guardian-card bg-white p-6">
        <div className="flex items-start gap-3">
          <div className="rounded-2xl bg-[#E8EEF6] p-3 text-[#163D6B]">
            <Bell size={20} />
          </div>
          <div>
            <h2 className="font-['Manrope'] text-xl font-semibold text-[#0F172A]">Notification activity</h2>
            <p className="mt-1 text-sm leading-6 text-[#64748B]">
              Log-only notifications are stored here for auditability and future provider integrations such as SMS and WhatsApp.
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-3">
        {notifications.length ? (
          notifications.map((notification) => {
            const Icon = iconsByCategory[notification.category] || ShieldAlert;
            return (
              <div key={notification.id} className="guardian-card bg-white p-5">
                <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
                  <div className="flex items-start gap-3">
                    <div className="rounded-2xl bg-[#F8FAFC] p-3 text-[#163D6B]">
                      <Icon size={18} />
                    </div>
                    <div>
                      <p className="font-semibold text-[#0F172A]">{notification.message}</p>
                      <p className="mt-1 text-sm text-[#64748B]">
                        {notification.recipient_name || "System user"} • {notification.recipient_role || "system"}
                      </p>
                    </div>
                  </div>
                    <div className="text-sm text-[#64748B] md:text-right">
                    <span className={`inline-flex rounded-full border px-3 py-1 text-xs font-semibold ${getStatusTone(notification.delivery_status || notification.status)}`}>
                      {getStatusLabel(notification.delivery_status || notification.status)}
                    </span>
                    <p className="mt-2">{formatDateTime(notification.timestamp)}</p>
                    <p className="mt-1 text-xs">Provider: {notification.provider}</p>
                    <p className="mt-1 text-xs">Channel: {notification.channel}</p>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="rounded-2xl border border-dashed border-[#CBD5E1] bg-white p-6 text-sm text-[#64748B]">No notification events have been recorded yet.</div>
        )}
      </div>
    </div>
  );
}
